<div class="main-content">
    <app-leaflet-map></app-leaflet-map>
    <app-sidebar-view></app-sidebar-view>
</div>